import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';

const sendEmailSupport = async (userInfo: any): Promise<ApiResponse<null>> => {
  const response = await axiosIns.post(`utils/support/send-mail`, {
    ...userInfo,
  });
  return response.data;
};

export default sendEmailSupport;
